var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33268 42.5951C7.18685 42.5951 6.20629 42.1874 5.39102 41.3721C4.57574 40.5569 4.1674 39.5756 4.16602 38.4284V13.4284C4.16602 12.2826 4.57435 11.302 5.39102 10.4867C6.20768 9.67144 7.18824 9.26311 8.33268 9.26172H41.666C42.8119 9.26172 43.7931 9.67005 44.6098 10.4867C45.4264 11.3034 45.8341 12.2839 45.8327 13.4284V38.4284C45.8327 39.5742 45.425 40.5555 44.6098 41.3721C43.7945 42.1888 42.8132 42.5964 41.666 42.5951H8.33268ZM24.9994 28.0117L41.666 17.5951V13.4284L24.9994 23.8451L8.33268 13.4284V17.5951L24.9994 28.0117Z",
    fill: "#07176D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7a0b18f63088587a6117710317bfe0d0.svg";
export { ForwardRef as ReactComponent };